module.exports = __webpack_public_path__ + "img/logo_row_white_vi.06b65f23.svg";